export enum EmployeeExistsResponse {
  EXISTS_MATCH,
  EXISTS_NO_MATCH,
  DOES_NOT_EXIST,
}
